<template>
	<div class="admin-tray">
		<slot></slot>
	</div>
</template>
<script>
	import { ref, computed, inject } from "vue";
	import { card } from "@/components";
	export default {
		components: {
			//"card": card
		},
		setup(props, context) {
			const section = ref({});
			const saving = ref(false);
			const sectionType = ref("");
			const sectionTypes = inject("$olympusSections");
			const componentOptions = Object.keys(sectionTypes);

			const isRichText = computed(() => {
				return sectionType.value === "OlympusRichText";
			});
			const isVueComponent = computed(() => {
				return !!componentOptions.find((o) => o === sectionType.value);
			});

			const Back = () => {
				context.emit("close");
			};
			const Save = () => {
				section.value.contentType = isRichText.value ? "OlympusRichText" : "OlympusVueComponent";
				section.value.componentType = !isRichText.value ? sectionType.value : "";
				saving.value = true;
				context.emit("save", { section: section.value, close: Back });
			};
			return {
				saving,
				sectionType,
				sectionTypes,
				componentOptions,
				section,
				isRichText,
				isVueComponent,
				Save,
				Back
			};
		}
	};
</script>
<style lang="scss">
	@use "@/assets/css/globalVars.scss" as *;

	.admin-tray {
		$padding: $margin-element-tiny;

		//position: absolute;
		left: 0;
		bottom: 0;

		display: flex;
		flex-direction: column;
		gap: $margin-element-tiny;
		align-items: stretch;
		justify-content: space-evenly;

		box-sizing: border-box;
		padding: $padding;
		width: 100%;
		//height: 20em;
		background-color: $color-background-darker;

		& .button.is-light {
			justify-content: flex-start;

			margin-left: -$padding;
			margin-right: -$padding;

			border-radius: 0;
			border: none;

			padding-left: 1rem;

			font-weight: 600; 
		}

		& .button[disabled] {
			background-color: rgba(0, 0, 0, 0.15);
			color: $text-gray;
		}
	}
</style>
